import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyD2Sa5eP1-CKj_gkwEaV19T1qC87buBUZE',
  authDomain: 'bimdrop-c35bd.firebaseapp.com',
  projectId: 'bimdrop-c35bd',
  storageBucket: 'bimdrop-c35bd.firebasestorage.app',
  messagingSenderId: '921648246309',
  appId: '1:921648246309:web:f5e2c9b02170cae77a59cc',
  measurementId: 'G-S282RMYT44',
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
